export default {
  operationsNamesArray: ['is', 'contains', 'startsWith', 'endsWith'],
  userAccountOperations: ['since', 'before', 'on'],
  riskFilterOperations: ['is'],
  userAccountKey: 'User Accounts',
  baseUrl: '/api/ada/queryengine/relationship?resourcetype=',
  baseUrlquery: '/api/ada/querybuilder/',
  baseUrlBritQuery: '/api/ada/queryengine/',
  paginationString: '&limit=10&offset=',
  paginationStringQuery: '?limit=10&offset=1',
  entityNames: ['users', 'groups', 'roles', 'permissions', 'userAccounts', 'resources'],
  appEnv: ['applications', 'environments'],
  queries: ['queries'],
  requestbody: {
    access: {
      accessDays: '',
      accessType: ''
    },
    activity: {
      activityPeriod: '',
      between: ''
    },
    before: '',
    contains: {
      appId: '',
      appName: '',
      appType: '',
      environmentId: '',
      environmentName: '',
      groupId: '',
      groupName: '',
      permissionId: '',
      permissionName: '',
      resourceId: '',
      resourceName: '',
      resourceType: '',
      roleId: '',
      roleName: '',
      userId: '',
      userAccountName: '',
      user: ''
    },
    endsWith: {
      appId: '',
      appName: '',
      appType: '',
      environmentId: '',
      environmentName: '',
      groupId: '',
      groupName: '',
      permissionId: '',
      permissionName: '',
      resourceId: '',
      resourceName: '',
      resourceType: '',
      roleId: '',
      roleName: '',
      userId: '',
      userAccountName: '',
      user: ''
    },
    is: {
      accountIdList: [],
      applicationList: [],
      applicationTypeList: [],
      environmentIdList: [],
      environmentNameList: [],
      groupNameList: [],
      permissionNameList: [],
      resourceIdList: [],
      resourceNameList: [],
      resourceTypeList: [],
      roleNameList: [],
      userAccountNameList: [],
      userList: []
    },
    on: '',
    since: '',
    risk: {
      riskRange: '',
      riskType: []
    },
    startsWith: {
      appId: '',
      appName: '',
      appType: '',
      environmentId: '',
      environmentName: '',
      groupId: '',
      groupName: '',
      permissionId: '',
      permissionName: '',
      resourceId: '',
      resourceName: '',
      resourceType: '',
      roleId: '',
      roleName: '',
      userId: '',
      userAccountName: '',
      user: ''
    }
  },
  oprPreValues: {
    appId: '',
    appName: '',
    appType: '',
    environmentId: '',
    environmentName: '',
    groupId: '',
    groupName: '',
    permissionId: '',
    permissionName: '',
    resourceId: '',
    resourceName: '',
    resourceType: '',
    roleId: '',
    roleName: '',
    userId: '',
    userAccountName: '',
    user: ''
  },
  entitiesCardNames: [{
    entityKeys: ['APPLICATION'],
    entityName: 'applications'
  }, {
    entityKeys: ['ENVIRONMENT_ID', 'ENVIRONMENT_NAME'],
    entityName: 'environments'
  }, {
    entityKeys: ['GROUP_NAME'],
    entityName: 'groups'
  }, {
    entityKeys: ['ROLE_NAME'],
    entityName: 'roles'
  }, {
    entityKeys: ['PERMISSION_NAME'],
    entityName: 'permissions'
  }, {
    entityKeys: ['USER_ACCOUNT_NAME'],
    entityName: 'user accounts'
  }, {
    entityKeys: ['SERVICE_RESOURCE_NAME', 'SERVICE_RESOURCE_TYPE'],
    entityName: 'resources'
  }, {
    entityKeys: ['USER'],
    entityName: 'users'
  }]
};